import { render, staticRenderFns } from "./EnterpriseConfirmation.vue?vue&type=template&id=b2f1a88e&"
import script from "./EnterpriseConfirmation.vue?vue&type=script&lang=js&"
export * from "./EnterpriseConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports